module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openCounterDialog.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive-demo p-datatable-gridlines",
    attrs: {
      "value": _vm.countersList,
      "paginator": true,
      "rows": 100,
      "first": 0,
      "filters": _vm.filters
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n          " + _vm._s(sl.index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "name",
      "sortable": true,
      "header": "Name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'name', $$v)
            },
            expression: "filters['name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "billPreFix",
      "header": "Bill Prefix",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billPreFix']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billPreFix', $$v)
            },
            expression: "filters['billPreFix']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "startBillNo",
      "header": "Start Bill No",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['startBillNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'startBillNo', $$v)
            },
            expression: "filters['startBillNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Cash Account",
      "field": "cashAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['cashAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'cashAccountName', $$v)
            },
            expression: "filters['cashAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Esewa Account",
      "field": "esewaAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['esewaAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'esewaAccountName', $$v)
            },
            expression: "filters['esewaAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Khalti Account",
      "field": "khaltiAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['khaltiAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'khaltiAccountName', $$v)
            },
            expression: "filters['khaltiAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bank Account",
      "field": "bankAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['bankAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'bankAccountName', $$v)
            },
            expression: "filters['bankAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Fonepay",
      "field": "fonePayAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['fonePayAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'fonePayAccountName', $$v)
            },
            expression: "filters['fonePayAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Nmc",
      "field": "darazAccountName",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['darazAccountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'darazAccountName', $$v)
            },
            expression: "filters['darazAccountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-success p-button-sm",
          attrs: {
            "type": "button",
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editCounter(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Counter Setup",
      "visible": _vm.showCounterDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showCounterDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCounter.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.saveAndNewCounter.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('Divider'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    ref: "name",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.counterName),
      callback: function($$v) {
        _vm.counterName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "counterName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6 p-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Bill Prefix")]), _vm._v(" "), _c('InputText', {
    model: {
      value: (_vm.billPreFix),
      callback: function($$v) {
        _vm.billPreFix = $$v
      },
      expression: "billPreFix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6 p-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Start Bill no")]), _vm._v(" "), _c('InputNumber', {
    model: {
      value: (_vm.startBillNo),
      callback: function($$v) {
        _vm.startBillNo = $$v
      },
      expression: "startBillNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "master"
    }
  }, [_vm._v("Is Master")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "id": "master",
      "binary": true
    },
    model: {
      value: (_vm.counterStatus),
      callback: function($$v) {
        _vm.counterStatus = $$v
      },
      expression: "counterStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("Cash Account")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Cash Account",
      "showClear": true
    },
    model: {
      value: (_vm.cashAccountId),
      callback: function($$v) {
        _vm.cashAccountId = $$v
      },
      expression: "cashAccountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("eSewa Account")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select eSewa Account",
      "showClear": true
    },
    model: {
      value: (_vm.eSewaAccountId),
      callback: function($$v) {
        _vm.eSewaAccountId = $$v
      },
      expression: "eSewaAccountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("Khalti Account")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Khalti Account",
      "showClear": true
    },
    model: {
      value: (_vm.khaltiAccountId),
      callback: function($$v) {
        _vm.khaltiAccountId = $$v
      },
      expression: "khaltiAccountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("Bank Account")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select bank Account",
      "showClear": true
    },
    model: {
      value: (_vm.bankAccountId),
      callback: function($$v) {
        _vm.bankAccountId = $$v
      },
      expression: "bankAccountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("Fonepay")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select fonePay Account",
      "showClear": true
    },
    model: {
      value: (_vm.fonePayAccountId),
      callback: function($$v) {
        _vm.fonePayAccountId = $$v
      },
      expression: "fonePayAccountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("Nmc")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.cashBankLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select daraz Account",
      "showClear": true
    },
    model: {
      value: (_vm.darazAccountId),
      callback: function($$v) {
        _vm.darazAccountId = $$v
      },
      expression: "darazAccountId"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.closeDeleteDialog,
      "deleted": _vm.deleteCounter
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3c6e5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/counter/counterSetup.vue
// module id = 2075
// module chunks = 0